import React from "react";
import { FaWallet } from "react-icons/fa";

import { formatNumber } from "../../../utils/convertToNumber";

const TransactionCard = ({ items }) => {
  const dataList = [
    items?.walletAffectedAmount > 0 && {
      title: "Wallet Affected",
      value: items?.walletAffectedAmount?.toFixed(2),
      icon: <FaWallet />,
      color: "danger",
    },
    items?.totalDiff > 0 && {
      title: "Wallet Gained",
      value: items?.totalDiff?.toFixed(2),
      icon: <FaWallet />,
      color: "warning",
    },
    // items?.bookingPaidByWallet?.total > 0 && {
    //   title: "Booking by Wallet",
    //   value: items?.bookingPaidByWallet?.total,
    //   icon: <FaWallet />,
    //   color: "warning",
    // },
    items?.depositByBankAmount > 0 && {
      title: "Total Deposit by Bank",
      value: items?.depositByBankAmount?.toFixed(2),
      icon: <FaWallet />,
      color: "warning",
    },
  ].filter(Boolean);

  return (
    <div className="row">
      {dataList?.map((item) => (
        <div className="col-xl-3 col-xxl-3 col-lg-6 col-sm-6">
          <div className="widget-stat card">
            <div className="p-3 card-body">
              <div className="media ai-icon">
                <span className={`me-3 bgl-${item?.color} text-${item?.color}`}>
                  {item?.icon}
                </span>
                <div className="media-body">
                  <p className="mb-1">{item?.title}</p>
                  <h4 className="mb-0 text-black">
                    {formatNumber(item?.value)}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TransactionCard;
